import React from "react"
import { Col, Accordion } from "react-bootstrap"

const Prices2 = () => {
  return (
    <Accordion>
      <Col className="pb-2">
        <Accordion.Item eventKey="400">
          <Accordion.Header>Is the Free Plan really free?</Accordion.Header>
          <Accordion.Body>
            Yes, Any month your orders count fall below 1k, It will be free.
          </Accordion.Body>
        </Accordion.Item>
      </Col>
      <Col className="pb-2">
        <Accordion.Item eventKey="401">
          <Accordion.Header>
            What is the difference between the free plan and the paid one?
          </Accordion.Header>
          <Accordion.Body>
            There is no difference, All paid Plans are exactly the same as the
            free plan.
          </Accordion.Body>
        </Accordion.Item>
      </Col>
      <Col className="pb-2">
        <Accordion.Item eventKey="402">
          <Accordion.Header>
            How do I change or upgrade my plan if I start on the Free Plan?
          </Accordion.Header>
          <Accordion.Body>
            You do not have to do anything, your plan will automatically be
            upgraded if your orders count increases above any plan threshold.
          </Accordion.Body>
        </Accordion.Item>
      </Col>
      <Col className="pb-2">
        <Accordion.Item eventKey="403">
          <Accordion.Header>
            Do i need to provide my billing information while using the free
            plan?
          </Accordion.Header>
          <Accordion.Body>
            You only need to provide your billing information if you received an
            invoice, if your orders count were below 1000, you will not receive
            an invoice that you need to pay.
          </Accordion.Body>
        </Accordion.Item>
      </Col>
      <Col className="pb-2">
        <Accordion.Item eventKey="404">
          <Accordion.Header>
            If i had an order with a quantity of 10pcs, is it counted as 1 or 10
            orders?
          </Accordion.Header>
          <Accordion.Body>
            It's counted as 1. The system does the same work for any order
            regardless of its quantity, so it's fair to count it as 1 order.
          </Accordion.Body>
        </Accordion.Item>
      </Col>
    </Accordion>
  )
}

export default Prices2
